import { render } from "./ReporteriaTablaTotales.vue?vue&type=template&id=0858cf7c"
import script from "./ReporteriaTablaTotales.vue?vue&type=script&lang=js"
export * from "./ReporteriaTablaTotales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__